import React from 'react';
import styled from 'styled-components';
import { Clients } from '~admin/view/components/clients/clients.component';
import { Column } from '~common/components/column.component';
import { ScrollBar } from '~web/view/theme/utils';

export const ClientsPage: React.FunctionComponent = () => {
  return (
    <Container>
      <Clients />
    </Container>
  );
};

const Container = styled(Column)`
  height: 100%;
  width: 100%;
  align-items: center;
  ${ScrollBar};
`;



// WEBPACK FOOTER //
// ./view/pages/clients.page.tsx